import {useCallback} from 'react';

import {useIsInLoadedReportContext} from '../../pages/ReportPage/LoadedReportContext';
import {makeTrackEvent} from '../../services/analytics/makeTrackEvent';

export type FilterLocation = 'workspace' | 'report';
export type FilterAction = 'Group created' | 'OR toggled';

export const trackRunFilters = makeTrackEvent<
  {
    action: FilterAction;
    location: FilterLocation;
  },
  {
    action: {
      description: 'what filter action was performed';
      exampleValues: ['Group created', 'OR toggled'];
    };
    location: {
      description: 'where the filter action occurred';
      exampleValues: ['workspace', 'report'];
    };
    _description: 'Tracks interactions with run filters';
    _location: 'workspaces, reports';
    _motivation: 'track AND/OR filter feature adoption';
  }
>('Run filters', {shouldLogToConsole: true});

export const useTrackFilterWithLocation = () => {
  const isReport = useIsInLoadedReportContext();
  const location: FilterLocation = isReport ? 'report' : 'workspace';

  const trackGroupCreated = useCallback(() => {
    trackRunFilters({action: 'Group created', location});
  }, [location]);

  const trackORToggled = useCallback(() => {
    trackRunFilters({action: 'OR toggled', location});
  }, [location]);

  return {trackGroupCreated, trackORToggled};
};
